module.exports = __webpack_public_path__ + "static/cambridge-021571ec165a3d3dca124085fe26c418.png";